import React from "react";
import {Table} from "antd";
import {JobPhotosResponse} from "../../../../../services/oneButtonServices/opportunityValidationService";
import {renderPairItem, renderStatusIcon} from "./OpportunityValidationShared";

interface JobPhotosProps {
    photos: JobPhotosResponse;
}

export const JobPhotos: React.FC<JobPhotosProps> = ({photos}) => {

    const columns = [
        {
            title: 'SFDC',
            dataIndex: 'items',
            width: '40%',
            render: (value: any) => renderPairItem(value[0]),
        },
        {
            title: 'SiteCapture',
            dataIndex: 'items',
            width: '40%',
            render: (value: any) => renderPairItem(value[1]),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: '20%',
            align: 'center',
        },
    ];

    const items = [
        {
            items: [
                {
                    name: 'No of Photos',
                    value: photos.sfdc.boxNoOfPhotos,
                },
                {
                    name: 'No of Photos',
                    value: photos.siteCapture.siteCapNoOfPhotos,
                },
            ],
            status: renderStatusIcon(
                photos.sfdc.boxNoOfPhotos != null &&
                photos.siteCapture.siteCapNoOfPhotos != null &&
                photos.sfdc.boxNoOfPhotos === photos.siteCapture.siteCapNoOfPhotos),
        },
        {
            items: [
                {
                    name: 'E-Bill Present',
                    value: photos.sfdc.boxNoOfEBill,
                },
                null,
            ],
            status: renderStatusIcon(photos.sfdc.boxNoOfEBill === "Yes"),
        },
        {
            items: [
                {
                    name: 'Photo Categories',
                    value: '', // Always empty, no data in PND.CV_Multi_classifier table
                },
                null,
            ],
        },
    ];

    return (
        <Table
            size={'small'}
            pagination={false}
            // @ts-ignore
            columns={columns}
            dataSource={items}/>
    );
};